import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByStatusOrder'
})
export class SortByStatusOrderPipe implements PipeTransform {
  transform(value: any, statusGrouping: Record<string, { order: number }>): any {
    if (!value) {
      return [];
    }

    return Object.entries(value)
      .sort(([keyA], [keyB]) => {
        const orderA = statusGrouping[keyA]?.order ?? Infinity;
        const orderB = statusGrouping[keyB]?.order ?? Infinity;
        return orderA - orderB;
      })
      .map(([key, data]) => ({ key, data }));
  }
}
